import { RibbonLogoIcon } from "Icons/RibbonLogo";
import { IconType } from "Icons/types";

import { ReactNode } from "react";

import { css } from "@emotion/react";

import { Avatar } from "components/shared/library/Avatar";
import { Typography } from "components/shared/library/Typography";

import { useWhiteLabel } from "contexts/WhiteLabelContext";

import { isViewMobile } from "utils/mediaQueryStrings";

import { mainStrokeGradient, uiGray } from "constants/colors";

const style = {
  header: css({
    display: "flex",
    justifyContent: "space-between",
    gap: 8,
    alignItems: "center",
  }),
  title: css({
    display: "flex",
    flexDirection: "column",
    gap: 4,
  }),
  logo: css({
    flexShrink: 0,
  }),
};

type Props = {
  title: string;
  subtitle: string | ReactNode;
  Icon?: IconType;
  customCompanyLogo?: string;
};
export const CandidateFlowCardHeader = ({
  title,
  subtitle,
  Icon = RibbonLogoIcon,
  customCompanyLogo,
}: Props) => {
  const whiteLabel = useWhiteLabel(false);
  const companyLogo = customCompanyLogo || whiteLabel?.interviewStyle?.logo;

  return (
    <div css={style.header}>
      <div css={style.title}>
        <Typography
          color={uiGray[100]}
          weight="bold"
          size={isViewMobile() ? "L" : "XL"}
        >
          {title}
        </Typography>
        <Typography color={uiGray[70]} size={isViewMobile() ? "XS" : "S"}>
          {subtitle}
        </Typography>
      </div>
      <div css={style.logo}>
        {companyLogo ? (
          <Avatar
            fileName={companyLogo}
            size={isViewMobile() ? 24 : 40}
            isOrg
          />
        ) : (
          <Icon
            width={isViewMobile() ? 24 : 40}
            height={isViewMobile() ? 24 : 40}
            strokeGradient={mainStrokeGradient.def}
            strokeGradientId={mainStrokeGradient.id}
          />
        )}
      </div>
    </div>
  );
};
